import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import { convertThenFormat } from "../../../common-data/Converts";
import { isDev } from "../../../common-data/Commons";
import { isAprovalAllowedEmail } from "../../../common-data/Accessibles";

const MembershipTransferRequestListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
}) => {
  const {
    membershipTransferRequestData,
    membershipTransferRequestLoading,
    membershipTransferRequestError,
  } = useSelector((state) => state.transfer);

  const isAdminCluster =
    userInfoData?.account_type === "admin" ||
    userInfoData?.account_type === "cluster_manager";
  const isApprovalAllowed =
    (isDev && isAdminCluster) || isAprovalAllowedEmail(userInfoData?.email);

  const iniTransferData = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniTransferData);

  useEffect(() => {
    if (
      !membershipTransferRequestLoading &&
      !membershipTransferRequestError &&
      membershipTransferRequestData?.status &&
      membershipTransferRequestData?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: membershipTransferRequestData.data,
        pagination:
          membershipTransferRequestData?.pagination?.length > 0
            ? membershipTransferRequestData.pagination
            : [],
      }));
    } else {
      setAllDatas(iniTransferData);
    }
  }, [
    membershipTransferRequestData,
    membershipTransferRequestLoading,
    membershipTransferRequestError,
  ]);

  const tbColumns = [
    {
      dataField: "details",
      text: "action",
      formatter: (_, row) => {
        const isPending = row?.status === "pending";

        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius27"
            style={{
              cursor: "pointer",
              background:
                row?.status === "pending"
                  ? "#EB8317"
                  : row?.status === "approved"
                  ? "#379C00"
                  : "#D90000",
              color: "#fff",
            }}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName:
                  row?.status === "pending" && isApprovalAllowed
                    ? "approval"
                    : "remarks",
                rowData: row,
              }))
            }>
            {isPending && isApprovalAllowed
              ? "click to approve/reject"
              : row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "user_from",
      text: "transfer from",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth150"
            // onClick={() => {
            //   setModValues((prevs) => ({
            //     ...prevs,
            //     isModOpen: true,
            //     modName: "plan-details",
            //     rowData: row,
            //   }));
            // }}
          >
            {row?.user_from_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.user_from_mobile || ""}
              <br />
              {row?.user_from_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "user_to",
      text: "transfer to",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.user_to_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.user_to_mobile || ""}
              <br />
              {row?.user_to_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_from",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.gym_from_name || "NA"}
          </span>
        );
      },
    },
    // {
    //   dataField: "transfered_by",
    //   text: "transferred by",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.transfered_by_name || "NA"}
    //         <br />
    //         <small className="lowercase underline gray">
    //           {row?.transfered_by_mobile || ""}
    //           <br />
    //           {row?.transfered_by_email || ""}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "transfered_fee",
      text: "transfer fee",
      formatter: (_, row) => (
        <span className="tb-data">
          {`₹${convertThenFormat(row?.transfered_fee || 0)}`}
        </span>
      ),
    },
    // {
    //   dataField: "aprv_rej_by",
    //   text: "approved/rejected by",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.aprv_rej_name || "NA"}
    //         <br />
    //         <small className="lowercase underline gray">
    //           {row?.aprv_rej_mobile || ""}
    //           <br />
    //           {row?.aprv_rej_email || ""}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "aprv_rej_date",
    //   text: "approved/rejected date",
    //   formatter: (_, row) => (
    //     <span className="tb-data minWidth100">
    //       {row?.aprv_rej_date ? formatDateTimezon(row.aprv_rej_date) : "-"}
    //     </span>
    //   ),
    // },
    // {
    //   dataField: "date_added",
    //   text: "transfer date",
    //   formatter: (_, row) => (
    //     <span className="tb-data minWidth100">
    //       {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
    //     </span>
    //   ),
    // },
    // {
    //   text: "Payment Link",
    //   formatter: (_, row) => {
    //     const isPaymentLink = row?.payment_link && row?.status === "approved";

    //     return (
    //       <span
    //         className="tb-data text-primary icon"
    //         style={{ textDecoration: "underline", textTransform: "lowercase" }}>
    //         {isPaymentLink ? (
    //           <a
    //             className=""
    //             rel="noreferrer"
    //             target="_blank"
    //             href={row?.payment_link}>
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="16"
    //               height="16"
    //               fill="currentColor"
    //               className="bi bi-box-arrow-up-right"
    //               viewBox="0 0 16 16"
    //               style={{
    //                 cursor: "pointer",
    //                 opacity: 1,
    //               }}>
    //               <path
    //                 fillRule="evenodd"
    //                 d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
    //               />
    //               <path
    //                 fillRule="evenodd"
    //                 d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
    //               />
    //             </svg>
    //           </a>
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-x-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#E41815", cursor: "not-allowed" }}>
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    //           </svg>
    //         )}

    //         <br />
    //         <small className="gray underline">
    //           {row?.payment_by?.replace(/_/g, " ") || "-"}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "action",
      text: "view details",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            account_type="button"
            className="actionBtn icon"
            disabled={false}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                rowData: row,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-eye-fill"
              viewBox="0 0 16 16">
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
      {membershipTransferRequestLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default MembershipTransferRequestListings;
